import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_listing_video = _resolveComponent("listing-video");
    const _component_lazy_load = _resolveComponent("lazy-load");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card = _resolveComponent("q-card");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_listing_video, {
            ref: "videoRef",
            "app-type": _ctx.appType,
            "listing-id": _ctx.listing.id,
            "user-type": "host",
            onShowVideo: _ctx.sendVideo
        }, null, 8, ["app-type", "listing-id", "onShowVideo"]),
        (_ctx.videoConfirmationData)
            ? (_openBlock(), _createBlock(_component_general_dialog, {
                key: 0,
                title: "Share Video",
                "model-value": _ctx.confirmVideoDialog,
                "onUpdate:modelValue": _ctx.toggleDialog,
                persistent: ""
            }, {
                "content-sections": _withCtx(() => [
                    _createVNode(_component_q_card, { flat: "" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_card_section, { class: "text-center q-pb-none" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_lazy_load, {
                                        alt: _ctx.videoConfirmationData.space_img_caption,
                                        url: _ctx.parseYTThumbnail(_ctx.videoConfirmationData.space_img_url),
                                        class: "justify-center",
                                        "pic-class": {
                                            'video-image cursor-pointer': true
                                        },
                                        format: "jpg",
                                        "component-size": "160px",
                                        "force-ratio": "",
                                        side: ""
                                    }, null, 8, ["alt", "url"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_q_card_section, { class: "text-center q-pb-none" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Are you sure that you would like to share " + _toDisplayString(_ctx.videoConfirmationData.space_img_caption) + " with the guest? ", 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_q_card_section, { class: "text-center q-pb-md" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                        label: "Share Video",
                                        class: "full-width",
                                        color: "positive",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.sendVideo$.next(_ctx.videoConfirmationData)))
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["model-value", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
    ], 64));
}
